<template>
<div class="detail">
    <h1 class="title">{{detail.now.name}}</h1>
    <p class="date">发布时间：{{detail.now.update_time}}</p>
    <div class="rich" v-html="detail.now.content"></div>
    <div class="bottom">
        <router-link :to="{path:$route.path,query:{id: detail.previous.id}}" tag="div" v-if="detail.previous.name">上一篇：{{ detail.previous.name}}</router-link>
        <div v-else>上一篇：无</div>
        <router-link :to="{path:$route.path,query:{id:detail.next.id}}" tag="div" v-if="detail.next.name">下一篇：{{ detail.next.name}}</router-link>
        <div v-else>下一篇：无</div>
    </div>
</div>
</template>

<script>
import {
    article_view
} from "../../assets/js/api";
export default {
    data() {
        return {
            detail: {},
        };
    },
    watch: {
        "$route.query.id": {
            handler(e) {
                article_view({
                    id: this.$route.query.id,
                }).then((r) => {
                    this.detail = r.data;
                });
            },
            deep: true,
        },
    },
    created() {
        article_view({
            id: this.$route.query.id,
        }).then((r) => {
            this.detail = r.data;
        });
    },
};
</script>

<style lang="less" scoped>
.detail {
    width: 990px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 12px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: white;
}

.title {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(62, 62, 62, 1);
    text-align: center;
}

.date {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    margin-top: 22px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(204, 204, 204, 1);
    text-align: center;
}

.bottom {
    margin-top: 60px;
    border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;

    div {
        width: 40%;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-overflow: ellipsis;
        overflow: hidden;
        transition: all 0.15s linear;
        cursor: pointer;
        white-space: nowrap;
    }

    div:hover {
        color: #126fcc;
    }
}
</style>
